import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import getConfig from '../../../util/config';

const propTypes = {
  children: PropTypes.node,
};

const BlackbaudLogin = ({ children, ...props }) => {
  const {
    oauth: { blackbaud },
    app: { baseUrl },
  } = getConfig();

  return (
    <Button
      {...props}
      href={`https://oauth2.sky.blackbaud.com/authorization?client_id=${blackbaud}&response_type=code&redirect_uri=${baseUrl}/auth/blackbaud/callback`}
    >
      {children}
    </Button>
  );
};

BlackbaudLogin.propTypes = propTypes;

export default BlackbaudLogin;
